import React from "react";
import InvalidCategory from "./InvalidCategory";
import InvalidTag from "./InvalidTag";
export var ERROR_CATEGORY = {
    name: "Error",
    tags: [],
    active: true,
    image: "",
    onMenu: false,
    url: "",
    uuid: "",
    type: "error",
    isGeolocationRelated: false
};
export var ALL_CATEGORY = { name: "perks.categories.allLabel", url: "", onMenu: true, tags: [] };
var isBadCategory = function (category) {
    return !category || category === ERROR_CATEGORY;
};
var isBadTag = function (category, tags) {
    return category && category !== ALL_CATEGORY && (tags === null || tags === void 0 ? void 0 : tags.length) === 0;
};
var BadCategoryOrTag = function (props) {
    var category = props.category, tags = props.tags, children = props.children;
    if (isBadCategory(category)) {
        return React.createElement(InvalidCategory, null);
    }
    if (isBadTag(category, tags)) {
        return React.createElement(InvalidTag, null);
    }
    return children;
};
export default BadCategoryOrTag;
